var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"selection d-flex",class:{selected: _vm.value},on:{"click":_vm.toggleSelection}})}
var staticRenderFns = []

export { render, staticRenderFns }